import React, { useEffect, useState } from 'react'
import {
  LeftShadowBox,
  ManageLeftDesc,
  ManageLeftTitle,
  ManagementGrid,
  ManagementGridTitle,
  ManagementIntroWrapper,
  ManagementItem,
  ManagementItemNumber,
  ManagementItemText,
} from './EcommerceIntroStyled'
import { ButtonGradient, ButtonGradientWrapper, CircleBackground, Container } from '../CommonStyled/CommonStyled'
import { Col, Row } from 'antd'
import { Fade } from 'react-awesome-reveal'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { BREAKPOINT, PAGES, REGISTER_ID, VIEW_MODE } from '../../constant'
import config from '../../config'

const EcommerceIntro = props => {
  const { ecommerceData, mode } = props
  const [animate, setAnimate] = useState(false)
  const [activeItem, setActiveItem] = useState({})
  const breakPoint = useRecoilValue(breakPointState)

  const handleClickRegister = () => {
    switch (mode) {
      case VIEW_MODE.PREVIEW:
        window.open(`${config.basePath}${PAGES.REGISTER_PREVIEW_SME.PATH}/${REGISTER_ID.ECOMMERCE}`, '_blank')
        break
      case VIEW_MODE.PUBLIC:
        window.open(`${config.basePath}${PAGES.REGISTER_SME.PATH}/${REGISTER_ID.ECOMMERCE}`, '_blank')
        break
      default:
        break
    }
  }

  const handleClickItem = item => {
    setActiveItem(item)
    setAnimate(e => !e)
  }

  const renderPadding = () => {
    switch (breakPoint) {
      case BREAKPOINT.XS:
      case BREAKPOINT.SM:
        return '0'
      default:
        return '40px 0'
    }
  }
  const renderGutter = () => {
    switch (breakPoint) {
      case BREAKPOINT.XS:
        return [0, 8]
      default:
        return [16, 16]
    }
  }

  useEffect(() => {
    if (ecommerceData?.featureArea?.length > 0) {
      setActiveItem(ecommerceData.featureArea[0])
    }
  }, [ecommerceData])

  return (
    ecommerceData?.featureArea?.length > 0 && (
      <ManagementIntroWrapper>
        <CircleBackground padding={renderPadding()}>
          <Container>
            <Row gutter={renderGutter()} justify={'center'} align={'stretch'}>
              <Col xxl={10} xl={12} lg={12} md={24} sm={24} xs={24}>
                <ManagementGrid>
                  {ecommerceData?.featureArea?.length > 0 &&
                    ecommerceData.featureArea.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleClickItem(item)}
                        className={`gridItem ${item.title === activeItem.title ? 'active' : 'inActive'}`}
                      >
                        <div className={'content'}>
                          <ManagementGridTitle>{item.title}</ManagementGridTitle>
                          <h2>Xem chi tiết</h2>
                        </div>
                      </div>
                    ))}
                </ManagementGrid>
              </Col>
              <Col xxl={10} xl={12} lg={12} md={24} sm={24} xs={24}>
                <LeftShadowBox>
                  <ManageLeftTitle>{activeItem?.title}</ManageLeftTitle>
                  <Fade key={animate}>
                    <ManageLeftDesc>{activeItem?.commonDescription}</ManageLeftDesc>
                  </Fade>

                  <ManagementItem>
                    <Fade key={animate} delay={300}>
                      <ManagementItemNumber>1</ManagementItemNumber>
                      <ManagementItemText>{activeItem.description1}</ManagementItemText>
                    </Fade>
                  </ManagementItem>
                  <ManagementItem>
                    <Fade key={animate} delay={600}>
                      <ManagementItemNumber>2</ManagementItemNumber>
                      <ManagementItemText>{activeItem.description2}</ManagementItemText>
                    </Fade>
                  </ManagementItem>
                  <ManagementItem>
                    <Fade key={animate} delay={900}>
                      <ManagementItemNumber>3</ManagementItemNumber>
                      <ManagementItemText>{activeItem.description3}</ManagementItemText>
                    </Fade>
                  </ManagementItem>
                </LeftShadowBox>
              </Col>
            </Row>
          </Container>
          {ecommerceData?.registerButton?.show && (
            <ButtonGradientWrapper margin={'24px 0 0 0'}>
              <ButtonGradient onClick={handleClickRegister}>{ecommerceData?.registerButton?.buttonText}</ButtonGradient>
            </ButtonGradientWrapper>
          )}
        </CircleBackground>
      </ManagementIntroWrapper>
    )
  )
}

export default EcommerceIntro
